import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentEditableEditor = styled.div`
  width: 75%;
  height: auto;
  .wrapper-class {
    border: 1px solid #ced4da;
    margin-bottom: 1em;
    background-color: ${({ theme }) => theme.neutral.white};
  }
  .editor-class {
    height: 5em;
  }
  .rdw-editor-toolbar.rich-text__toolbar {
    display: ${(props) => (props.showOnFocus ? "none" : "flex")};
  }
  .rdw-editor-wrapper:focus-within .rich-text__toolbar {
    display: flex;
  }
`;
